/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconLogout = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M23.25 12.004H7.5M11.25 15.754l-3.75-3.75 3.75-3.75" />
        <path d="M20.693 16.6c-2.538 5.214-8.822 7.383-14.036 4.845S-.726 12.623 1.812 7.409 10.634.026 15.848 2.564a10.5 10.5 0 0 1 4.666 4.494" />
      </g>
    </svg>
  ),
);
